import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const AngleLeftIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "angleLeftIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M18.9726 20.0005C18.7505 20.0005 18.5284 19.9157 18.3588 19.7461L11.227 12.6143C10.8879 12.2752 10.8879 11.7258 11.227 11.3866L18.3588 4.25485C18.6979 3.9157 19.2474 3.9157 19.5865 4.25485C19.9257 4.594 19.9257 5.14343 19.5865 5.48258L13.0686 12.0005L19.5865 18.5184C19.9257 18.8575 19.9257 19.407 19.5865 19.7461C19.4169 19.9157 19.1948 20.0005 18.9726 20.0005Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.1597 20.0005C11.9375 20.0005 11.7154 19.9157 11.5458 19.7461L4.41403 12.6143C4.07488 12.2752 4.07488 11.7258 4.41403 11.3866L11.5458 4.25485C11.8849 3.9157 12.4344 3.9157 12.7735 4.25485C13.1127 4.594 13.1127 5.14343 12.7735 5.48258L6.25562 12.0005L12.7735 18.5184C13.1127 18.8575 13.1127 19.407 12.7735 19.7461C12.604 19.9157 12.3818 20.0005 12.1597 20.0005Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default AngleLeftIcon;
